import "./index.css";

import {
  Button,
  Card,
  Col,
  Progress,
  theme
} from "antd";
import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { getProfileLocal, setProfileLocal } from "../../../../utils/common";

import { BiConversation } from "react-icons/bi";
import { FaRegCopy } from "react-icons/fa";
import { ImAttachment } from "react-icons/im";
import { MdOutlineContentPaste } from "react-icons/md";
import { api_url } from "../../../../services/api";

const { useToken } = theme;

export default function CardCourse(props) {
  const { courses } = props;
  const [filterIsVisible, setFilterIsVisible] = useState(false);
  const { token } = useToken();

  const navigate = useNavigate();
  const [current, setCurrent] = useState("/");

  const onClickMenu = (item) => {
    const clicked = menuItem.find((_item) => _item.key === item.key);
    navigate(clicked.key);
    setCurrent("");
  };

  const menuItem = [
    {
      label: "Conteúdo",
      key: "/mycourses/content",
      icon: <FaRegCopy />,
    },
    {
      label: "Fórum",
      key: "/mycourses/forum",
      icon: <BiConversation />,
    },
    {
      label: "Material",
      icon: <ImAttachment />,
      key: "/mycourses/material",
    },
    {
      label: "Avaliação",
      key: "/mycourses/evaluation",
      icon: <MdOutlineContentPaste />,
    },
  ];

  const completed = props.percent === 100 ? true : false;


  return (
    <Col xs={24} sm={12} lg={12} xl={10} xxl={8}>
      <Card
        className="card"
        cover={
          <img
            alt="Imagem thumnail do curso"
            style={{
              backgroundColor: "#F5DB33",
            }}
            src={`${api_url}/upload/${courses.course_thumbnail}`

            }
          />
        }
      >
        {!completed ? (
          <>
          </>
        ) : null}
        <div className="flex">
          <div className="card-body">
            <span>{courses?.course_name || "Nome do curso"}</span>
            <span>Turma: {courses?.team_code}</span>
            <div className="percent">
              <span className="text-percent">
                {courses?.course_period || "Periodo do curso"}
              </span>
              <span className="text-percent">{props.percent.toFixed(2)}%</span>
            </div>

            <div className="container-progress">
              <Progress
                percent={props.percent}
                strokeColor={token.colorFillSecondary}
                trailColor="#DDDDDD"
              />
            </div>
            <Link
              className='link-wrapper-button'
              to={`/mycourses/${courses.course_hash}`}
            >
              <Button
                className="continue"
                disabled={completed}
                onClick={() => {
                  setProfileLocal({ ...getProfileLocal(), enrollment_hash: courses.enrollment_hash })
                }}
              >
                {completed ? "Curso concluído!" : "Acessar Painel"}
              </Button>
            </Link>
          </div>
        </div>
      </Card>
    </Col>
  );
}
